<template>
  <div class="row border-bottom">
    <nav class="navbar navbar-static-top" role="navigation" style="margin-bottom: 0">
      <div class="navbar-header">
        <a v-if="!hideExpandButton"
          class="navbar-minimalize minimalize-styl-2 btn btn-primary"
          href="#">
          <i class="fa fa-bars"></i>
        </a>
      </div>
      <ul class="nav navbar-top-links navbar-right">
        <li>
          <a class="m-r-sm text-muted welcome-message">
            Bienvenue {{ user.firstname }} {{ user.lastname }}
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import store from '../config/store'

export default {
  props: {
    hideExpandButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    store
  }),

  computed: {
    user() {
      return store.data.user
    }
  }
}
</script>
